module.exports = __webpack_public_path__ + "static/media/hadith.977b96d2.png";